/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgProcessesAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m7.2 10-.4-2c-3 .6-3.8 3.5-3.8 5h2c0-.1 0-2.6 2.2-3zm9.6 0c2.2.4 2.2 2.9 2.2 3h2c0-1.5-.8-4.4-3.8-5l-.4 2zM12 1.6 6.6 7l5.4 5.4L17.4 7 12 1.6zM9.4 7 12 4.4 14.6 7 12 9.6 9.4 7zm4.6 7v8h8v-8h-8zm6 6h-4v-4h4v4zM6 14c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgProcessesAlt as ProcessesAlt };
